import { useTranslation } from 'react-i18next';

import { capitalizeFirstLettersInWords } from '^/util/capitalizeFirstLetterInWords';

type ReservationDetailMobileOfficeInfoCardProps = {
  title: string;
  officeName: string;
  officeAddress: string;
  officePhone: string;
  officeHours: string;
};

export const ReservationDetailMobileOfficeInfoCard = ({
  title,
  officeName,
  officeAddress,
  officePhone,
  officeHours,
}: ReservationDetailMobileOfficeInfoCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <p className="text-big font-bold">{title}</p>
      <p className="text-default font-light">{t(`location_name.${officeName}`)}</p>
      <div className="rounded-[8px] bg-secondary-gray-light p-3 text-sm">
        <div className="flex gap-3">
          <span className="w-[60px] text-[#989EA4]">주소</span>
          <span className="font-normal text-[#34393E]">
            {capitalizeFirstLettersInWords(officeAddress)}
          </span>
        </div>
        <div className="mt-1.5 flex gap-3">
          <span className="w-[60px] text-[#989EA4]">전화번호</span>
          <span className="font-normal text-[#34393E]">{officePhone}</span>
        </div>
        <div className="mt-1.5 flex gap-3">
          <span className="w-[60px] text-[#989EA4]">운영시간</span>
          <span className="font-normal text-[#34393E]">{officeHours.replace('null', '__')}</span>
        </div>
      </div>
    </div>
  );
};
